import Vue from "vue";
import store from "./../../store";

Vue.directive('can-or', {
    bind(el, binding, vnode) {
        const { value } = binding
        let hasPermission = false
        const role = store.getters.role
        if (role && role != null && role != undefined && role.permissions) {
            if (value && value instanceof Array && value.length > 0) {
                value.forEach(element => {
                    hasPermission = hasPermission || role.permissions.some(perm => perm.slug === element)
                });
            } else {
                hasPermission = hasPermission || role.permissions.some(perm => perm.slug === value)
            }
        }
        if (!hasPermission) {
            el.style.display = 'none'
        }
    }
});

Vue.directive('can', {
    bind(el, binding) {
        const value = binding.value
        const role = store.getters.role
        const userPerms = role ? (role.permissions ? role.permissions.map(p => p.slug) : null) : []

        const required = Array.isArray(value) ? value : [value]

        const hasAll = required.every(p => userPerms.includes(p))

        if (!hasAll) el.style.display = 'none'
    }
});

Vue.prototype.$can = function (permissions, { all = false } = {}) {
    const role = store.getters.role
    if (!role || !role.permissions) return false

    const userPerms = role.permissions.map(p => p.slug)

    if (Array.isArray(permissions)) {
        return all
            ? permissions.every(p => userPerms.includes(p))   // нужны ВСЕ
            : permissions.some(p => userPerms.includes(p))    // нужно ХОТЯ БЫ одно
    }

    return userPerms.includes(permissions)
}
